export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5282.9d39c125.jpg";